import React, { Component } from "react";
import Chart from "react-apexcharts";

function EmployeePieChart({ showSelect }) {
  console.log(showSelect);
  const chart_one = {
    series: [showSelect == "Month" ? 147 : 70, 1654],
    options: {
      colors: ["#85c122", "#1850a8"],
      labels: ["Total Employee", "New Employee"],
      dataLabels: {
        enabled: true,
        enabledOnSeries: 10,
        textAnchor: "middle",
      },
      subtitle: {
        align: "center",
      },
      legend: {
        show: false,
      },
    },
  };
  return (
    <Chart
      options={chart_one.options}
      series={chart_one.series}
      type="pie"
      width="300"
      height="300"
    />
  );
}

export default EmployeePieChart;
